var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DefaultSearchContext, WebSocketRequest } from '../utils/constants';
export var types = {
    SET_PROCESS_DATA: 'SET_PROCESS_DATA',
    SEARCH_PROCESS_DATA: 'SEARCH_PROCESS_DATA',
    EDIT_PROCESS_DATA: 'EDIT_PROCESS_DATA',
    EDIT_PROCESS_SUCCESS_DATA: 'EDIT_PROCESS_SUCCESS_DATA',
    ADD_NEW_PROCESS: 'ADD_NEW_PROCESS',
    ADD_NEW_DOCUMENT_PROCESS: 'ADD_NEW_DOCUMENT_PROCESS',
    UPDATE_DOCUMENT_PROCESS: 'UPDATE_DOCUMENT_PROCESS',
    MOVE_PROCESS: 'MOVE_PROCESS',
    MOVE_EMBEDDED_PROCESS: 'MOVE_EMBEDDED_PROCESS',
    GET_UPDATED_PROCESS: 'GET_UPDATED_PROCESS',
    GET_UPDATED_PROCESSES: 'GET_UPDATED_PROCESSES',
    ADD_EMBEDDED_PROCESS: 'ADD_EMBEDDED_PROCESS',
    UPDATE_EMBEDDED_PROCESS_DOCUMENT: 'UPDATE_EMBEDDED_PROCESS_DOCUMENT',
    ADD_DOCUMENT_EMBEDDED_PROCESS: 'ADD_DOCUMENT_EMBEDDED_PROCESS',
    ADD_PROCESS_CLAIM: 'ADD_PROCESS_INSTANCE_CLAIM',
    REMOVE_PROCESS_CLAIM: 'REMOVE_PROCESS_CLAIM',
    ADD_PROCESS_WITH_EMBEDDED: 'ADD_PROCESS_WITH_EMBEDDED',
    SEARCH_PROCESS_IDS: 'SEARCH_PROCESS_IDS',
    SET_SEARCH_PROCESS_IDS: 'SET_SEARCH_PROCESS_IDS',
    UPDATE_EMBEDDED_PROCESS: 'UPDATE_EMBEDDED_PROCESS'
};
export var addProcessClaim = function (_a) {
    var processName = _a.processName, ids = _a.ids;
    return {
        type: types.ADD_PROCESS_CLAIM,
        payload: {
            ids: ids,
            processName: processName,
        },
    };
};
export var removeProcessClaim = function (_a) {
    var processName = _a.processName, ids = _a.ids;
    return {
        type: types.REMOVE_PROCESS_CLAIM,
        payload: {
            ids: ids,
            processName: processName,
        },
    };
};
export var getUpdatedProcess_AC = function (id, webSocketOrigin) {
    var _a;
    if (webSocketOrigin === void 0) { webSocketOrigin = false; }
    return {
        type: types.GET_UPDATED_PROCESS,
        payload: (_a = {
                id: id
            },
            _a[Symbol.for(WebSocketRequest)] = webSocketOrigin,
            _a),
    };
};
export var getUpdatedProcesses_AC = function (ids) {
    return {
        type: types.GET_UPDATED_PROCESSES,
        payload: {
            ids: ids,
        },
    };
};
export var addNewProcess_AC = function (_a) {
    var modelAlias = _a.modelAlias, values = _a.values, executeAlias = _a.executeAlias;
    return {
        type: types.ADD_NEW_PROCESS,
        payload: {
            modelAlias: modelAlias,
            values: values,
            executeAlias: executeAlias,
        },
    };
};
export var addEmbeddedProcess_AC = function (_a) {
    var id = _a.id, values = _a.values, embeddedProcessAlias = _a.embeddedProcessAlias, executeAlias = _a.executeAlias;
    return {
        type: types.ADD_EMBEDDED_PROCESS,
        payload: {
            id: id,
            values: values,
            embeddedProcessAlias: embeddedProcessAlias,
            executeAlias: executeAlias,
        },
    };
};
export var addNewDocumentProcess_AC = function (_a) {
    var modelAlias = _a.modelAlias, values = _a.values, executeAlias = _a.executeAlias, document = _a.document, documentAlias = _a.documentAlias;
    return {
        type: types.ADD_NEW_DOCUMENT_PROCESS,
        payload: {
            modelAlias: modelAlias,
            values: values,
            executeAlias: executeAlias,
            document: document,
            documentAlias: documentAlias,
        },
    };
};
export var updateDocumentProcess_AC = function (_a) {
    var id = _a.id, document = _a.document, documentAlias = _a.documentAlias;
    return {
        type: types.UPDATE_DOCUMENT_PROCESS,
        payload: {
            id: id,
            document: document,
            documentAlias: documentAlias,
        },
    };
};
export var updateEmbeddedProcessDocument_AC = function (_a) {
    var id = _a.id, document = _a.document, documentAlias = _a.documentAlias, path = _a.path;
    return {
        type: types.UPDATE_EMBEDDED_PROCESS_DOCUMENT,
        payload: { id: id, document: document, documentAlias: documentAlias, path: path },
    };
};
export var editProcess_AC = function (requests, callback) {
    return {
        type: types.EDIT_PROCESS_DATA,
        payload: {
            requests: requests,
            callback: callback,
        },
    };
};
export var editProcessSuccess_AC = function (requests, apiVersion) {
    return {
        type: types.EDIT_PROCESS_SUCCESS_DATA,
        payload: __assign(__assign({}, requests), { apiVersion: apiVersion }),
    };
};
export var setProcessData_AC = function (modelAlias, _a, searchID) {
    var data = _a.data;
    if (searchID === void 0) { searchID = DefaultSearchContext; }
    return {
        type: types.SET_PROCESS_DATA,
        payload: {
            modelAlias: modelAlias,
            searchID: searchID,
            data: data,
        },
    };
};
export var searchProcessData_AC = function (modelAlias, queries, searchID, fetchAllIds) {
    if (searchID === void 0) { searchID = DefaultSearchContext; }
    if (fetchAllIds === void 0) { fetchAllIds = false; }
    return {
        type: types.SEARCH_PROCESS_DATA,
        payload: {
            modelAlias: modelAlias,
            searchID: searchID,
            queries: queries,
            fetchAllIds: fetchAllIds
        },
    };
};
export var moveProcess_AC = function (id, executeAlias) {
    return {
        type: types.MOVE_PROCESS,
        payload: {
            id: id,
            executeAlias: executeAlias,
        },
    };
};
export var moveEmbeddedProcess_AC = function (id, executeAlias, path, embeddedId) {
    return {
        type: types.MOVE_EMBEDDED_PROCESS,
        payload: {
            id: id,
            executeAlias: executeAlias,
            path: path,
            embeddedId: embeddedId,
        },
    };
};
export var addProcessWithEmbeddedProcess = function (modelAlias, values, embeddedProcessValues, embeddedPath) {
    return {
        type: types.ADD_PROCESS_WITH_EMBEDDED,
        payload: {
            modelAlias: modelAlias,
            values: values,
            embeddedProcessValues: embeddedProcessValues,
            embeddedPath: embeddedPath,
        },
    };
};
export var addDocumentEmbeddedProcess_AC = function (_a) {
    var id = _a.id, values = _a.values, embeddedProcessAlias = _a.embeddedProcessAlias, executeAlias = _a.executeAlias, document = _a.document, documentAlias = _a.documentAlias;
    return {
        type: types.ADD_DOCUMENT_EMBEDDED_PROCESS,
        payload: {
            id: id,
            values: values,
            embeddedProcessAlias: embeddedProcessAlias,
            executeAlias: executeAlias,
            document: document,
            documentAlias: documentAlias,
        },
    };
};
export var searchProcessIds_AC = function (modelAlias, queries, searchID) {
    return {
        type: types.SEARCH_PROCESS_IDS,
        payload: {
            modelAlias: modelAlias,
            queries: queries,
            searchID: searchID
        },
    };
};
export var setSearchProcessIds_AC = function (modelAlias, _a, searchID) {
    var data = _a.data;
    return {
        type: types.SET_SEARCH_PROCESS_IDS,
        payload: {
            modelAlias: modelAlias,
            data: data,
            searchID: searchID
        }
    };
};
export var updateEmbeddedProcess_AC = function (_a) {
    var id = _a.id, alias = _a.alias, value = _a.value, embeddedPath = _a.embeddedPath;
    return {
        type: types.UPDATE_EMBEDDED_PROCESS,
        payload: {
            id: id,
            alias: alias,
            value: value,
            embeddedPath: embeddedPath
        }
    };
};
//# sourceMappingURL=process.js.map